const initialState = {
  data: false,
  loading: false,
  status: 0,
  dataForgetPass: {},
  loadingForgetPass: false,
  statusForgetPass: 0,
  dataChangePass: {},
  loadingChangePass: false,
  statusChangePass: 0,
  dataChangeLanguage: {},
  loadingChangeLanguage: false,
  statusChangeLanguage: 0,
};

export default initialState;
